module.exports = __webpack_public_path__ + "img/tokido-tag.c00b9839.png";